module.exports = __webpack_public_path__ + "img/1185x407px.0c75eee7.png";